import { Directive } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]',
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(input)': 'onInputChange($event)',
    '(drag)': 'onInputChange($event)',
    '(drop)': 'onInputChange($event)',
  },
  standalone: false,
})
export class OnlyNumbersDirective {
  constructor() {}

  onInputChange(event) {
    if (event) {
      const onlyNumbers = event.target.value.replace(/[^0-9.]+/g, '');
      onlyNumbers
        ? (event.target.value = parseFloat(onlyNumbers))
        : (event.target.value = onlyNumbers);
      // if (event.target.value.match(/^[0-9]*$/)) {
      //     return true;
      // } else {
      //     event.target.value = event.target.value.substr(0, event.target.value.length - 1);
      //     return false;
      // }
      /*
            if (event.key.match(/[^\w\s]/gi, '')) {
                return false;
            }
            */
    }
  }
}
